import React, { useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import "../../styles/spa.css";
import Logo from "../../assets/images/logo-with-text.png";
import { CircularProgress } from "@material-ui/core";
import withMiddleware from "../../middleware";
import { useHistory } from "react-router-dom";
import { getInvitationDetails, processInvitation } from "./handler";
import { routeAfterLoginOrSignup, getRoutes } from "../auth/login/handler";
import { logoutUser } from "../../actions";
import { showToast } from "../../utils/toast";

function Invitation(props) {
  const [isLoading, setIsLoading] = useState(true);
  const [inviteDetails, setInviteDetails] = useState();
  const history = useHistory();
  const { user } = useSelector((state) => ({
    user: state.app.user,
  }));
  const dispatch = useDispatch();

  const invite_token = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    const invite_token = params.get("it");
    return invite_token;
  }, []);

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);

        if (!invite_token) {
          setInviteDetails({ error: "Invitation link is not valid!!" });
          return;
        }
        const details = await getInvitationDetails(props.service, invite_token);
        if (!details?.accountSameAsEmail) {
          setInviteDetails({
            error: `The email address you used to access the invitation does not match the one the invitation was sent to. Please ensure you are signed in with the correct account associated with the invitation.\nIf needed, you can also request the sender to resend the invitation to your current account email <b>${user?.email}</b>`,
          });
          return;
        }
        setInviteDetails(details);
      } catch (err) {
        setInviteDetails(err);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [user?.email, invite_token]);

  const handleProcessInvitation = async (decision) => {
    try {
      setIsLoading(true);
      await processInvitation(props.service, invite_token, decision);
      debugger;
      routeAfterDecision();
    } catch (error) {
      showToast("error", error?.error || error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const routeAfterDecision = () => {
    const route = getRoutes(user?.user_type);
    routeAfterLoginOrSignup(history, route, user, true);
  };
  return (
    <div id="invitation-container">
      <img src={Logo} className="app-logo" alt="OptimalHRV Logo" />
      <div className="top-right-ele" onClick={routeAfterDecision}>
        <span>
          <b>Skip for now</b>
        </span>
      </div>
      <div className="content">
        {isLoading ? (
          <CircularProgress size={60} />
        ) : !inviteDetails?.error ? (
          <>
            <h3 className="title">
              You are invited to join <u>{inviteDetails?.org_name}</u> organization's <u>{inviteDetails?.group_name}</u> group
            </h3>
            <p>
              Once you Accept the invite you will be added to this organization's group and your data will be shared with organization and group
              admins. If you don't want to be added to this organization you can click on reject. Also you can be removed from the group anytime at
              your request.
            </p>
            <div className="actions">
              <button onClick={() => handleProcessInvitation("rejected")} className="red">
                Reject
              </button>
              <button onClick={() => handleProcessInvitation("accepted")} className="green">
                Accept
              </button>
            </div>
          </>
        ) : (
          <>
            <h1
              style={{
                margin: 0,
              }}
            >
              Something went wrong!
            </h1>
            <p dangerouslySetInnerHTML={{ __html: inviteDetails?.error || "Sorry the invitation link is expired!!" }} />
          </>
        )}
        <div className="account-selection">
          <span>
            You are logged in as:{"  "}
            <b>
              {user?.first_name} {user?.last_name}
            </b>
          </span>
          <div className="logout-section">
            <span>Want to join through another account?</span>
            <div
              className="logout"
              onClick={() => {
                dispatch(logoutUser());
              }}
            >
              <b>Logout</b>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withMiddleware(Invitation);
